import request from "@/util/http"; // 收藏列表查询

export var getCollectionList = function getCollectionList(params) {
  return request({
    url: "/admin/personalCenter/collection/list",
    method: "get",
    params: params
  });
};